import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { TCreateGiftCategory } from './types'

export const setGiftCategory = createEvent<TCreateGiftCategory>()
export const submitCreateGiftCategory = createEvent<TCreateGiftCategory>()
export const $giftCategory = restore(setGiftCategory, {
  id: 0,
  name: '',
  title: '',
  description: '',
  isShow: false,
  sorting: 0,
})

export const createGiftCategory = fx<TCreateGiftCategory, void>({
  method: 'POST',
  url: '/giftshop/gift_category',
})

sample({
  clock: submitCreateGiftCategory,
  fn: (giftCategory) => {
    return {
      url: `/giftshop/gift_category`,
      body: { ...giftCategory },
    }
  },
  target: createGiftCategory,
})
